import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { InterventoAttivoService } from './services/intervento-attivo.service';

@Injectable({
  providedIn: 'root'
})
export class InterventoAttivoGuard  {

  constructor(private interventoAttivo: InterventoAttivoService) {

  }
  canActivate(
    _next: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.interventoAttivo.isInterventoSelezionato;
  }
  
}
